// extracted by mini-css-extract-plugin
export default {"verbosity":"VerbositySlider_verbosity__5giJ8"};